import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker';
import { amount_img, build_img, cart_img, chat_img, home_img, live_img, lock_dash_img, mmc_dash_img } from '../../assets/imgs';
import moment from 'moment';

const CurrentDateSelected = ({ dateList, setFromDate, setToDate, fromDate, toDate, dashDateDetails }) => {

    const [midhun, setMidhun] = useState(false);

    useEffect(() => {
        if (!midhun) {
            const today = moment();
            setFromDate(today);
            setToDate(today);
            dashDateDetails(today, today);
            setMidhun(true);
        }
    }, [midhun]);


    return (
        <div>
            <div className='d-flex ac-js my-4 gap-3' >
                <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 primary">
                    Select Date :
                </p>
                <div className="w-15">
                    <DatePicker
                        selected={fromDate ? fromDate.toDate() : new Date()}

                        onChange={(date) => {
                            const momentDate = moment(date);
                            setFromDate(momentDate);
                            dashDateDetails(momentDate, toDate);
                        }}
                        dateFormat="dd-MM-yyyy"
                        className="input-pop-new ps-2 w-100"
                        placeholderText="From Date"
                        type='date'
                    />
                </div>
                <div className='w-15'>
                    <DatePicker
                        selected={toDate ? toDate.toDate() : new Date()}
                        onChange={(date) => {
                            const momentDate = moment(date);
                            setToDate(momentDate);
                            dashDateDetails(fromDate, momentDate);
                        }}

                        dateFormat="dd-MM-yyyy"
                        className="input-pop-new ps-2 w-100"
                        placeholderText="To Date"
                        type='date'
                    />
                </div>
            </div>
            <div className='d-flex flex-wrap gap-4 '>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={build_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{dateList?.total_bookings}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Bookings</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={home_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{dateList?.total_checkin}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Check In</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={lock_dash_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{dateList?.total_checkout}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Check Out</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={cart_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{dateList?.total_cancelled}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Cancelled</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={mmc_dash_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{dateList?.total_mmc_amount}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>MMC</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={amount_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{dateList?.total_booking_amount}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Booking Amount</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={live_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{dateList?.live_properties}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Property Live</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={chat_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{dateList?.chat_init_count}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Chat Initiated</h4>
                </div>
            </div>
        </div>
    )
}

export default CurrentDateSelected